import { FC } from 'react';

import bootstrapPage, { BootstrapPageProps } from '../HOCs/bootstrapPage';
import MetaHead from '../components/MetaHead';
import RecoverySection, {
  RecoverySectionProps
} from '../components/auth/recovery/RecoverySection/index';
import Layout from '../components/layouts/Layout';

const PasswordRecoveryRequestPage: FC<Omit<
  BootstrapPageProps & RecoverySectionProps,
  'title' | 'subtitle' | 'backgroundVariant'
>> = props => (
  <>
    <MetaHead title="Password recovery | Wave.video" />
    <Layout navigationVariant="white" mainVariant="contain">
      <RecoverySection
        title="Password Recovery Request"
        subtitle="We will email you a password recovery link"
        backgroundVariant="white-to-light-blue"
        {...props}
      />
    </Layout>
  </>
);

export default bootstrapPage(PasswordRecoveryRequestPage);
